// src/db-enums/shared-analysis-links.ts
import { z } from "zod";
var SharedLinkTypeEnum = z.enum(["legacy", "explicit_result"]);

export {
  SharedLinkTypeEnum
};
